export default __webpack_public_path__ + "static/media/thumbnail.b2935c89.png";